
/*
 * VENTI — THE VENTI EDIT · scroll reveal (Phase 2B)
 * - One IntersectionObserver for all venti-edit sections; safe to include many times.
 * - Only elements that START off-screen are hidden (.ve-off) and then revealed once.
 *   Without JavaScript, or with prefers-reduced-motion, nothing is ever hidden.
 * - Dispatches no events and touches nothing outside [data-ve-reveal] inside .ve.
 */
(function () {
  if (window.VentiEditReveal) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var observer = null;

  function markSeen(el) {
    el.setAttribute('data-ve-seen', '');
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var el = entry.target;
      if (entry.isIntersecting) {
        el.classList.remove('ve-off');
        el.classList.add('ve-in');
        observer.unobserve(el);
      } else if (!el.hasAttribute('data-ve-seen')) {
        el.classList.add('ve-off');
      }
      markSeen(el);
    });
  }

  function init(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.ve [data-ve-reveal]:not([data-ve-seen])');
    if (!els.length) return;

    if (reduce || designMode || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, markSeen);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(onIntersect, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    Array.prototype.forEach.call(els, function (el) { observer.observe(el); });
  }

  window.VentiEditReveal = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  if (designMode) {
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  }
})();
